import { render } from "./index.vue?vue&type=template&id=ebe0f90c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ebe0f90c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe0f90c"]])

export default __exports__